import { observable } from 'mobx';

export type NonOrderItemPriceDetailResponseArgs = {
  id: number;
  price: number;
};

export type NonOrderItemPriceDetailArgs = {
  id: number;
  price: number;
};

export const convertNonOrderItemPriceDetailResponseToArgs = (response: NonOrderItemPriceDetailResponseArgs) => {
  const args: NonOrderItemPriceDetailArgs = {
    id: response.id,
    price: response.price
  };
  return args;
};

export default class NonOrderItemPriceDetail {
  @observable id: number;
  @observable price: number;

  constructor(args: NonOrderItemPriceDetailArgs) {
    this.id = args.id;
    this.price = args.price;
  }
}
